<div class="box card-box m-x-sm">
  <div class="box-body">
    <ng-container
      gp-roles
      [userRoles]="['SDCONNECT_ADMIN']"
      *ngIf="sdc2">
      <button class="btn btn-sm btn-outline-primary m-a-sm"
              test-id="force-refresh-status-btn"
              (click)="forceRefreshStatus()"
              placement="bottom" [adaptivePosition]="false" container="body" triggers="mouseenter:mouseleave"
              tooltip="Retrieve last statuses from SDConnect and refresh sdc Logs on SDWP">
        <em class="fa fa-light fa-sync"></em>&nbsp;Refresh statuses (SDC2)
      </button>
      <button class="btn btn-sm btn-outline-primary m-a-sm"
              test-id="force-sync-data-btn"
              (click)="forceSyncData('Salary')"
              placement="bottom" [adaptivePosition]="false" container="body" triggers="mouseenter:mouseleave"
              tooltip="Force push data of entity 'Salary' from SDWP to SDConnect and LPE">
        <em class="fa fa-light fa-sync"></em>&nbsp;Resync Salary (SDC2)
      </button>
    </ng-container>
    <ng-container
      gp-roles
      [userRoles]="['SDC3_ADMIN']"
      *ngIf="sdc3">
      <button class="btn btn-sm btn-outline-primary m-a-sm"
              test-id="force-sync-person-sdc3-btn"
              (click)="forceSyncPersonToSDC3()"
              placement="bottom" [adaptivePosition]="false" container="body" triggers="mouseenter:mouseleave"
              tooltip="Send person from SDWP (delta + failed since last sync) to SDC3 and LPE">
        <em class="fa fa-light fa-sync"></em>&nbsp;Resync person (SDC3)
      </button>
      <button class="btn btn-sm btn-outline-primary m-a-sm"
              test-id="send-test-message-sdc3-btn"
              (click)="sendTestMessageToSDC3()"
              placement="bottom" [adaptivePosition]="false" container="body" triggers="mouseenter:mouseleave"
              tooltip="Send test message from SDWP to SDC3 and LPE">
        <em class="fa fa-light fa-send"></em>&nbsp;Send test message (SDC3)
      </button>
    </ng-container>
    <ng-container
      gp-roles
      [userRoles]="['SDC3_ADMIN']"
      *ngIf="sdc3">
      <hr class="m-y-sm"/>
      <div class="form-group" [formGroup]="sdc3ConfigFormGroup">
        <div class="mode-selector" id="sdc3ConfigMode">
          <label class="m-b-0 mode-label">Mode</label>
          <div class="mode-dropdown-wrapper">
            <button type="button" class="mode-trigger" (click)="toggleModeDropdown($event)">
              <span class="mode-trigger__value">{{ sdc3ConfigFormGroup.controls.mode.value }}</span>
              <em class="fa fa-light fa-chevron-down mode-trigger__chevron"
                  [class.open]="modeDropdownOpen"></em>
            </button>
            <ng-container *ngIf="modeDropdownOpen">
              <div class="mode-dropdown-backdrop" (click)="closeModeDropdown()"></div>
              <ul class="mode-dropdown"
                  [style.top.px]="modeDropdownPosition.top"
                  [style.left.px]="modeDropdownPosition.left"
                  [style.min-width.px]="modeDropdownPosition.minWidth">
                <li *ngFor="let mode of sdc3ConfigModes"
                    class="mode-dropdown__item"
                    [class.active]="mode === sdc3ConfigFormGroup.controls.mode.value"
                    (click)="selectMode(mode)">
                  {{ mode }}
                </li>
              </ul>
            </ng-container>
          </div>
        </div>
        <div class="m-t-sm partial-entities" *ngIf="sdc3ConfigFormGroup.controls.mode.value === SDC3ConfigModes.PARTIAL"
             formGroupName="partials">
          <div class="partial-entity" *ngFor="let entity of sdc3ConfigEntities">
            <label class="ui-switch va-middle">
              <input type="checkbox" [formControlName]="entity" [id]="'partial-' + entity">
              <em></em>
            </label>
            <span class="va-middle m-l-xs">{{ entity }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div class="box card-box m-x-sm">
  <div class="box-header logs-tabs-header">
    <div class="nav nav-tabs">
      <div class="nav-item text-center" (click)="activeLogTab = 'sdc'">
        <a class="nav-link block text-ellipsis" [ngClass]="{'active': activeLogTab === 'sdc'}">
          <span>Sdc logs</span>
        </a>
      </div>
      <div class="nav-item text-center" *ngIf="sdc3" gp-roles [userRoles]="['SDC3_ADMIN']"
           (click)="activeLogTab = 'person'">
        <a class="nav-link block text-ellipsis" [ngClass]="{'active': activeLogTab === 'person'}">
          <span>Person logs</span>
        </a>
      </div>
    </div>
    <ul class="nav logs-tabs-tools">
      <li class="nav-item inline m-r-1" *ngIf="activeLogTab === 'person'">
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" id="onlyLatestCheckbox"
                 (change)="toggleDisplayLatestPersonLogsOnly($event)"
                 [checked]="displayLatestPersonLogsOnly">
          <label class="form-check-label" for="onlyLatestCheckbox">Display latest only</label>
        </div>
      </li>
      <li class="nav-item inline">
        <a class="nav-link" (click)="reloadActiveLogs()">
          <i class="fa-solid fa-rotate"></i>
        </a>
      </li>
    </ul>
  </div>
  <div class="box-body">
    <gp-sdc-logs-list *ngIf="activeLogTab === 'sdc' && contractId"
                      [contractId]="contractId"
                      [excludedTypes]="[SdcEventTypes.SDC3_PAYROLL_INPUT]"></gp-sdc-logs-list>
    <gp-person-payroll-logs-list *ngIf="activeLogTab === 'person'"
                                 [contractId]="contractId"
                                 [latestOnly]="displayLatestPersonLogsOnly"
                                 [sdcLogType]="SdcEventTypes.SDC3"></gp-person-payroll-logs-list>
  </div>
</div>
